/**
 * Per-customer payment settings (recurring failure policy + categories).
 * Backed by /api/customers/:id/payment-settings (added in 0070).
 */
import { apiFetch } from './client';

export type RecurringOnMaxFail =
  | 'suspend' | 'suspend_and_notify' | 'notify_only' | 'cancel';

export interface CustomerPaymentSettings {
  recurring_retry_max: number;
  recurring_retry_delay_days: number;
  recurring_on_max_fail: RecurringOnMaxFail;
  payment_categories: string[];
  // 0071
  notification_phone: string | null;
  notification_recipients_extra: string[];
}

export type PatchCustomerPaymentSettings = Partial<CustomerPaymentSettings>;

export const customerPaymentSettings = {
  get: (customerId: string) =>
    apiFetch<CustomerPaymentSettings>(
      `/api/customers/${customerId}/payment-settings`,
    ),
  patch: (customerId: string, body: PatchCustomerPaymentSettings) =>
    apiFetch<CustomerPaymentSettings>(
      `/api/customers/${customerId}/payment-settings`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
};
